// Stub for Ingresos and Ajustes. The sidebar entries stay visible on purpose:
// the operator should carry the mental map of the full surface even before
// these ship.

const EnConstruccion = ({ title }) => (
  <div className="bg-white border border-slate-200 rounded-2xl p-16 text-center">
    <p className="text-sm font-bold text-slate-900">{title}</p>
    <p className="text-xs text-slate-400 mt-2">En construcción — disponible después del expo.</p>
  </div>
);

export default EnConstruccion;
